module.exports = __webpack_public_path__ + "static/media/profilepic-jin.2023.af951ba6.jpg";